import getComposerFocusSurface from '@/lib/getComposerFocusSurface.js';

const normalizeThreadSurfaceSubmitRequest = (payload) => {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }

  const threadId = String(payload?.threadId || '').trim();
  const submissionToken = String(payload?.submissionToken || '').trim();
  const source = String(payload?.source || '').trim();
  const sourceSurface = getComposerFocusSurface(payload?.sourceSurface);
  const startedAt = String(payload?.startedAt || '').trim() || new Date().toISOString();

  if (!threadId || !submissionToken || !source || !sourceSurface) {
    return null;
  }

  return {
    threadId,
    submissionToken,
    source,
    sourceSurface,
    startedAt
  };
};

export default normalizeThreadSurfaceSubmitRequest;
